import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { Panel, Button, Col, Row, HelpBlock } from 'react-bootstrap';
import { FormActions, DateTimeInput, Input } from '../../../common/components/formControls';
import CentersDropdownList from '../../centers/DropdownList';
import { withTranslation } from 'react-i18next';
import utils from '../../../common/services/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, reset, loading, pristine, t, onSubmit }) => {
	const handleReset = () => {
		reset();
		setTimeout(() => handleSubmit());
	};
	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit(values => onSubmit({ ...values }))}>
					<Row>
						<Col sm={6}>
							<CentersDropdownList render='field' name='centerId' filter={center => !center.isKindergarten} label={t('CampaignStats_Center')} />
						</Col>
						<Col sm={3}>
							<Field name='paymentDateFrom' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodFrom()} label={t('CampaignStats_PaymentDate')} placeholder={t('Common_From')} />
						</Col>
						<Col sm={3}>
							<Field name='paymentDateTo' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodTo()} placeholder={t('Common_To')} label='&nbsp;' />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='campaignName' component={Input} type='text' label={t('CampaignStats_CampaignName')} />
						</Col>
						<Col sm={6}>
							<Field name='campaignMedium' component={Input} type='text' label={t('CampaignStats_CampaignMedium')} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='campaignSource' component={Input} type='text' label={t('CampaignStats_CampaignSource')} />
						</Col>
					</Row>
					<FormActions>
						<Button onClick={handleSubmit(values => onSubmit({ ...values }))} disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<Button onClick={handleSubmit(values => onSubmit({ ...values, exportFormat: 'Excel' }))} disabled={loading} bsStyle='warning'>{t('Common_ExportToExcel')}</Button>
						<Button disabled={pristine || loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
					<HelpBlock>{t('Common_ExportHelpText')}</HelpBlock>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'campaignStatsFilter' })(withTranslation()(Filter));